import React, {FC} from 'react';
import {Image as AuroraImage, IMAGE_RESIZE_MODES} from '@lookiero/aurora';
import {IMAGES_URL} from '@cdn';

const MAINTENANCE_IMAGE_BASE = `${IMAGES_URL()}/maintenance/v1/maintenance`;

export const MAINTENANCE_IMAGE = `${MAINTENANCE_IMAGE_BASE}@1x.webp`;

export const MAINTENANCE_IMAGE_SRC_SET = [1, 2, 3]
  .map(density => `${MAINTENANCE_IMAGE_BASE}@${density}x.webp ${density}x`)
  .join(', ');

export const Image: FC = () => {
  return (
    <AuroraImage
      src={MAINTENANCE_IMAGE}
      srcSet={MAINTENANCE_IMAGE_SRC_SET}
      resizeMode={IMAGE_RESIZE_MODES.cover}
      style={{width: '100%', height: '100%'}}
    />
  );
};
